/* eslint-disable import/no-cycle */
import React, { useContext, useEffect, useState } from 'react';
import { GetStaticProps } from 'next';
import AuthContext from 'AppContext/AuthProvider';
import WithPage from '../HOC/Page/WithPage';
import Typo from '../components/Typo';
import MainLayout from '../layout/MainLayout';
import { getSiteData } from '../models/Contentful';
import type { Page } from '../models/Contentful/types';
import { DefaultPage, IStaticPageProps } from '../models/Contentful/types';
import { LayoutPage } from '../types/page';
import { LogInFormSSO, withLink } from '../components/Auth/LogInForm';

const LogIn: LayoutPage<IStaticPageProps<DefaultPage>> = () => {
  const { setTwoFactor } = useContext(AuthContext);
  const [signUpLink, setSignUpLink] = useState<string>('sign-up');
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get('partner') === 'true') {
      setSignUpLink('sign-up?partner=true');
    }
    setTwoFactor(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div>
        <main>
          <LogInFormSSO
            // title="Let’s Go!"
            // description={
            //   <Typo>
            //     Sign in to access all things KnoPro. Need a refresher on using
            //     the platform? Check out our “How It Works” video on the homepage
            //     or {withLink("visit our FAQs", "faq")} for tips on making the
            //     most of KnoPro.
            //   </Typo>
            // }
            subHeading="or sign in with your Email"
            signUpLink={<Typo>Need an account? {withLink('Sign Up', signUpLink)}</Typo>}
          />
        </main>
      </div>
    </div>
  );
};

// export default WithAuth();
export default WithPage(LogIn, true, true);
// export default LogIn;

LogIn.getLayout = function getLayout(
  page: React.ReactElement,
  props: IStaticPageProps<DefaultPage>,
) {
  return <MainLayout {...props}>{page}</MainLayout>;
};

export const getStaticProps: GetStaticProps<IStaticPageProps<DefaultPage>> = async () => {
  const siteData = await getSiteData();

  return { props: { site: siteData.site, page: {} as Page & DefaultPage } };
};
